import React, { PropsWithChildren, useCallback } from 'react';
import { MaterialIcon } from './MaterialIcon';

import './Chip.scss';

interface ChipProps<T = undefined> {
  readonly id: string;
  readonly value: T;
  readonly onDismiss?: (value: T) => void;
}

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint, @typescript-eslint/no-explicit-any
export const Chip = <T extends any>({
  onDismiss,
  children,
  id,
  value,
}: PropsWithChildren<ChipProps<T>>): React.JSX.Element => {
  const onDismissInner = useCallback(() => {
    onDismiss!(value);
  }, [onDismiss, value]);

  return (
    <div className="chip" id={id}>
      {children}
      {onDismiss ? (
        <span className="chip-dismiss" onClick={onDismissInner}>
          <MaterialIcon name="close" small />
        </span>
      ) : null}
    </div>
  );
};
